<!-- PortfoloiHoldingsAreaContainer.vue -->
<template>
  <div>
    <div class="tabs-wrapper">
      <div class="tabs is-large">
        <ul>
          <li 
            v-if="checkupStore.holdingsFromPortfolios?.length > 0" 
            :class="{ 'is-active': activeTab === 0 }" 
            @click="activeTab = 0"
          >
            <a>Portfolio Holdings</a>
          </li>
          <li 
            v-if="checkupStore.benchmark" 
            :class="{ 'is-active': activeTab === 1 }" 
            @click="activeTab = 1"
          >
            <a>Benchmark Holdings</a>
          </li>
          <li 
            v-if="checkupStore.optimizedPortfolio" 
            :class="{ 'is-active': activeTab === 2 }" 
            @click="activeTab = 2"
          >
            <a>Proposed Holdings</a>
          </li>
        </ul>
      </div>
      <div class="toggle-wrapper">
        <IncludeInPresentationToggle name="Holdings" />
      </div>
    </div>

    <div class="tab-content">
      <div v-if="activeTab === 0">
        <PortfolioHoldingsArea />
      </div>
      <div v-if="activeTab === 1">
        <PortfolioHoldingsAreaStatic portfolioType="benchmark" />
      </div>
      <div v-if="activeTab === 2">
        <PortfolioHoldingsAreaStatic portfolioType="optimizedPortfolio" />
      </div>
    </div>
  </div>
</template>

<script>
import PortfolioHoldingsAreaStatic from '@frontend/ui/features/checkup/components/PortfolioHoldingsAreaStatic.vue';
import PortfolioHoldingsArea from '@frontend/ui/features/checkup/components/PortfolioHoldingsArea.vue';
import IncludeInPresentationToggle from '@frontend/ui/features/checkup/components/sidebar/IncludeInPresentationToggle.vue';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { mapStores } from 'pinia';

export default {
  name: 'PortfolioHoldingsAreaContainer',
  components: {
    PortfolioHoldingsAreaStatic,
    PortfolioHoldingsArea,
    IncludeInPresentationToggle,
  },
  data() {
    return {
      activeTab: 0, // Initial value will be updated in created()
    };
  },
  computed: {
    ...mapStores(useCheckupStore),
  },
  created() {
    // Determine which tab should be active by default based on available data
    this.setDefaultActiveTab();
  },
  methods: {
    setDefaultActiveTab() {
      // If no portfolio, set benchmark tab as default active
      if (!this.checkupStore.holdingsFromPortfolios?.length > 0 && this.checkupStore.benchmark) {
        this.activeTab = 1;
      } 
      // If no portfolio and no benchmark, set optimizedPortfolio as default active
      else if (!this.checkupStore.holdingsFromPortfolios?.length > 0 && !this.checkupStore.benchmark && this.checkupStore.optimizedPortfolio) {
        this.activeTab = 2;
      }
      // Otherwise, keep the default (which is portfolio if it exists)
      else if (this.checkupStore.holdingsFromPortfolios?.length > 0) {
        this.activeTab = 0;
      }
      // If nothing is available, default to the first available tab
      else {
        // Find the first available tab
        if (this.checkupStore.optimizedPortfolio) {
          this.activeTab = 2;
        }
      }
    }
  },
  watch: {
    'checkupStore.benchmark'(newVal) {
      if (newVal) {
        this.setDefaultActiveTab();
      }
    },
    'checkupStore.optimizedPortfolio'(newVal) {
      if (newVal) {
        this.setDefaultActiveTab();
      }
    },
    'checkupStore.holdingsFromPortfolios'(newVal) {
      if (newVal?.length > 0) {
        this.setDefaultActiveTab();
      }
    },
  },
};
</script>

<style scoped>
.tabs-wrapper {
  background-color: white;
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 1rem;
}

.tabs {
  margin-bottom: 0;
  flex-grow: 1;
}

.tabs ul {
  border-bottom-color: #dbdbdb;
}

.tabs a {
  color: #494949;
  font-weight: 500;
}

.tabs li.is-active a {
  color: #6c7ae0;
  font-weight: 600;
  border-bottom-color: #6c7ae0;
}

/* Style specifically for the toggle wrapper to override tab styles */
.toggle-wrapper {
  /* Isolate it from the tabs styling */
  color: #494949;  
  margin-left: 1rem;
}

/* Override any potential inheritance issues */
.toggle-wrapper :deep(.tw-whitespace-nowrap) {
  color: #494949;
}

.tab-content {
  background-color: white;
  padding-top: 0;
}

/* This ensures there's no gap between tabs and content */
.tab-content > div {
  margin-top: 0;
  padding-top: 0;
}

.box {
  max-width: 350px;
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
}
</style>